/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Dirs_Table_CredentialInputs */

const es_settings_dirs_table_credential = /** @type {(inputs: Settings_Dirs_Table_CredentialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cuenta`)
};

const en_settings_dirs_table_credential = /** @type {(inputs: Settings_Dirs_Table_CredentialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Account`)
};

/**
* | output |
* | --- |
* | "Account" |
*
* @param {Settings_Dirs_Table_CredentialInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const settings_dirs_table_credential = /** @type {((inputs?: Settings_Dirs_Table_CredentialInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Dirs_Table_CredentialInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_settings_dirs_table_credential(inputs)
	return en_settings_dirs_table_credential(inputs)
});
export { settings_dirs_table_credential as "settings.dirs.table.credential" }